














import { Component, Mixins } from 'vue-property-decorator';
import MixinResults from '@/plugins/podolib/services/helper/mixins/results';
import ChartRunningPhaseDetailed from '@/components/charts/running/ChartRunningPhaseDetailed.vue';
import { get } from 'lodash';

@Component({
  components: {
    ChartRunningPhaseDetailed,
  },
})
export default class PatientsResultsRunningDetailed extends Mixins(MixinResults) {
  get isNewAnalysis() {
    return this.$pdc.helper?.isNewAnalysis(this.acquisition.computed_data);
  }
  get validSegments() {
    return this.acquisition.computed_data.segments.filter(
      (x: any) =>
        x.left.result.aggregates.contact_time.avg !== 0 &&
        x.right.result.aggregates.contact_time.avg !== 0 &&
        this.acquisition.computed_data.aggregates.left.percent_flight_time,
    );
  }
  get acquisitionTreadmill() {
    let speed = !!this.acquisition.data.treadmill_speed;
    return speed ? this.acquisition.data.treadmill_speed : speed;
  }
}
